/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1Route } from '../models/V1Route';
import { HttpFile } from '../http/http';

export class V1CreateRouteRequest {
    'route'?: V1Route;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "route",
            "baseName": "route",
            "type": "V1Route",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1CreateRouteRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

